<div
  class="w-100 text-align-center assets-container"
  [ngClass]="{ 'text-align-start': asset()?.quantity > 0 }"
>
  @if (asset()?.quantity > 0) {
    <p class="bt-3 text-onback-medium">
      <span class="t-5">
        {{ asset()?.price | thousands }}
      </span>
      ریال
    </p>
    <p class="c-1 text-onback-medium">{{ asset()?.quantity | number: '1.0-0' }} واحد</p>
  } @else {
    <p class="bt-3 text-onback-medium">
      دارایی فعلی شما
      <span class="t-5 text-onback-high is-currency"> {{ 0 }} ریال</span>
      است.
    </p>
    <p class="bt-3 mt-micro text-onback-medium">برای افزایش دارایی سرمایه‌گذاری کنید.</p>
  }
</div>
